import { SEARCH_CONTEXTS, SearchContext } from './context/types';

/**
 * Determine what the default search context should be if none is set in the query param
 */
export function getDefaultSearchContext() {
    return SEARCH_CONTEXTS.URGENT_LEADS_CONTEXT;
}

/**
 * Determine the searchContext based on the set tab + feature toggles
 * @param tab
 * @returns
 */
export function getFeatureAwareSearchContext(tab: SearchContext) {
    if (tab === SEARCH_CONTEXTS.UNREAD_MESSAGES_CONTEXT) {
        return SEARCH_CONTEXTS.URGENT_LEADS_CONTEXT;
    }
    return tab;
}
